import React from 'react';

export default function AdminProductsHeader({
  totalCount,
  filteredCount,
  lastRefreshedAt,
  refreshing,
  onRefresh,
  children,
}) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between mb-6">
      <div className="flex items-center gap-3">
        <div className="text-xl font-bold"><a href='/admin/dashboard' className='hover:underline'>Admin</a> · Products</div>
        <span className="text-xs px-2 py-1 rounded-full bg-gray-100 text-gray-600">{totalCount} total</span>
        {typeof filteredCount === 'number' && (
          <span className="text-xs px-2 py-1 rounded-full bg-black text-white text-center" title="Filtered count">
            {filteredCount} shown
          </span>
        )}
      </div>

      <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center">
        {children}
        <div className="flex items-center gap-2">
          {lastRefreshedAt && (
            <span className="text-xs text-gray-500 hidden sm:inline">
              Refreshed {lastRefreshedAt.toLocaleTimeString()}
            </span>
          )}
          <button
            className="bg-black text-white px-4 py-2 rounded disabled:opacity-60"
            disabled={refreshing}
            onClick={onRefresh}
            title="Fetch and sync from remote API"
          >
            {refreshing ? 'Refreshing…' : 'Refresh'}
          </button>
        </div>
      </div>
    </div>
  );
}